import { Injectable } from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Router} from '@angular/router';
import {BackendApi, localhost} from '../config/backend-api';
import {Registration} from '../model/user/registration';
import {PatientRegistration} from '../model/user/PatientRegistration';

@Injectable({
  providedIn: 'root'
})
export class RegistrationService {

  constructor(private httpClient: HttpClient,
              private router: Router) {}

  public register(registration: Registration) {
    console.log(registration);
    return this.httpClient
      .post(localhost + BackendApi.REGISTRATION, registration, {responseType: 'text', observe: 'response'})
      .subscribe(d => {
          if (d.status === 200) {
            this.router.navigateByUrl('/success').then(() => setTimeout(() => location.replace('/startup'), 1500));
          }
        },
        error => {
          console.log(error);
          this.router.navigateByUrl('/error').then(() => setTimeout(() => location.replace('/startup'), 1500));
        });
  }

  public registerPatient(patientRegistration: PatientRegistration, category: string) {
    console.log(patientRegistration);
    // tslint:disable-next-line:max-line-length
    return this.httpClient.post(localhost + BackendApi.PATIENT_REGISTRATION + patientRegistration.email + '/' + category, patientRegistration, {responseType: 'text', observe: 'response'});
  }

}
